import React from 'react'

const FiveNew = ({ addBall, i }) => {
  return (
    <div onClick={() => addBall(i)} className='flex flex-col justify-center items-center'>

    <div className='relative w-[35px] h-[35px] bg-gray-300 rounded-full cursor-pointer flex justify-center items-center'>
        <p className={`text-center `}>{i}</p>
    </div>
    </div>
  )
}

export default FiveNew